import { appUtils } from 'lib/AppUtils'
import { FC, Fragment, PropsWithChildren } from 'react'
import useSWRImmutable from 'swr/immutable'

import { AllCompetitions } from '@/components/Competition'
import BannerSlider from '@/components/homepage/BannerSlider'
import HowToPlay from '@/components/homepage/HowToPlay'
import LatestWinners from '@/components/homepage/LatestWinners'
import WebInfo from '@/components/homepage/WebInfo'
import WinnerCarousel from '@/components/homepage/WinnerCarousel'
import { useLanguage } from '@/hooks/Contexts'
import { API_URL } from '@/utils/Consts'

// `heading` is the page's own h1. The homepage and /competitions share this component, so
// without it both rendered the same site-wide strapline and Google saw two distinct pages
// making an identical relevance claim — they then split the ranking for the same queries
// instead of one of them owning it. Defaults to the old value so nothing else shifts.
export const CompetitionsPageContent: FC<PropsWithChildren<{ dataFetched?: any; bannersFetched?: any; heading?: string }>> = ({
  dataFetched,
  bannersFetched,
  heading,
}) => {
  const { navigation: navStr } = useLanguage()
  const { data, isValidating, isLoading } = useSWRImmutable(dataFetched ? null : `${API_URL.competitionList}?store_id=1&source=c`, appUtils.fetcher)
  return (
    <Fragment>
      <h1 className='sr-only'>{heading || navStr.meta.title}</h1>
      <BannerSlider initialBanners={bannersFetched} />
      {dataFetched ? <AllCompetitions data={dataFetched} /> : <AllCompetitions data={isValidating || isLoading ? null : data || []} />}
      <WebInfo />
      <WinnerCarousel />
      <HowToPlay />
      <LatestWinners />
    </Fragment>
  )
}
export default CompetitionsPageContent
